import CampusBlock from 'src/components/CampusBlock/CampusBlock';
import CampusSelect from '../../components/FiltersSection/CampusSelect/CampusSelect';
import CheckBoxField from 'src/components/Fields/CheckBoxField';
import DataPicker from 'src/components/DataPicker';
import InformBlock from 'src/components/InformBlock';
import InputField from 'components/Fields/InputFields/InputField';
import InputTextArea from 'components/Fields/InputFields/InputTextArea';
import SelectField from 'components/Fields/SelectFields/SelectField';
import InternalHeader from '../../components/InternalHeader/InternalHeader';

import NoteBlockForTable from '../../components/TableElements/NoteBlockForTable/NoteBlockForTable';
import PatientBlockForTable from '../../components/TableElements/PatientBlockForTable/PatientBlockForTable';
import PractitionerBlock from 'src/components/PractitionerBlock/PractitionerBlock';
import TimeBlockForTable from '../../components/TableElements/TimeBlockForTable/TimeBlockForTable';
import TimePicker from 'src/components/TimePicker';

import PractitionersList from '../../components/FiltersSection/PractitionersSelect';
import AppointmentStatusFilter from '../../components/FiltersSection/AppointmentStatusFilter/AppointmentStatusFilter';
import DateFilter from '../../components/FiltersSection/DateFilter/DateFilter';


export default {
  AppointmentStatusFilter,
  CampusBlock,
  CampusSelect,
  CheckBoxField,
  DataPicker,
  DateFilter,
  InformBlock,
  InputField,
  InputTextArea,
  InternalHeader,
  NoteBlockForTable,
  PatientBlockForTable,
  PractitionerBlock,
  PractitionersList,
  SelectField,
  TimeBlockForTable,
  TimePicker
};